var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#2181FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2306 14.1H19.4095C21.0968 14.1 22.4646 15.4678 22.4646 17.1551V23.0467C22.4646 23.4502 22.1375 23.7773 21.734 23.7773H13.5551C11.8678 23.7773 10.5 22.4095 10.5 20.7222V14.8306C10.5 14.4271 10.8271 14.1 11.2306 14.1Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6441 16.3765L24.6441 16.3765L27.2492 14.1338L27.2492 14.1338C27.2773 14.1096 27.3076 14.1 27.3347 14.1H27.3923C27.4123 14.1 27.4356 14.1077 27.4583 14.1318C27.4815 14.1564 27.5 14.195 27.5 14.2443V23.7557C27.5 23.805 27.4815 23.8436 27.4583 23.8682C27.4356 23.8923 27.4123 23.9 27.3923 23.9H27.3347C27.3076 23.9 27.2773 23.8904 27.2492 23.8662L27.2492 23.8662L24.6441 21.6235L24.3189 22.0013L24.6441 21.6235C24.3743 21.3913 24.2068 21.038 24.1978 20.6533L24.1593 19L24.1978 17.3467C24.2068 16.9621 24.3743 16.6087 24.6441 16.3765Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLinkIcon);
export default __webpack_public_path__ + "static/media/zoomLinkIcon.014498b1074d3cebd47d64d3fe979ad6.svg";
export { ForwardRef as ReactComponent };